import DynamicTable from '@atlaskit/dynamic-table';
import { Box } from '@atlaskit/primitives';

export const Status = () => {
    const head = {
        cells: [
            { key: 'siteName', content: 'Site Name' },
            { key: 'cloudId', content: 'CloudId' },
            { key: 'botEmail', content: 'System Email' },
            { key: 'status', content: 'Status' },
            { key: 'installedby', content: 'Onboarded By' },
        ]
    };

    const rows = [
        {
            key: '1',
            cells: [
                {
                    key: 'siteName',
                    content: 'John Doe',
                },
                {
                    key: 'cloudId',
                    content: '1234567890',
                },
                {
                    key: 'botEmail',
                    content: 'john.doe@example.com',
                },
                {
                    key: 'status',
                    content: 'Active',
                },
                {
                    key: 'installedby',
                    content: 'John Doe',
                },
            ],
        }
    ];

    return (
        <Box style={{ width: '100%', height: '100%', padding: '20px' }}>
            <Box>
                <Box>You are already onboarded to use Rovo app on Slack</Box>
                <Box style={{ marginBottom: '24px' }}>Onboarding details</Box>
            </Box>
            <DynamicTable
                head={head}
                rows={rows}
                rowsPerPage={5}
                defaultPage={1}
                loadingSpinnerSize="large"
                isRankable
                testId="table"
            />
        </Box>
    )
}